/* eslint-disable no-param-reassign */
import { Paragraph, Sentence } from './TextSegment.d';

const paragraphLookup = (
  sentences: Sentence[]
): Paragraph[] => {
  const groupedSentences = sentences.reduce((groups, sentence) => {
    const { paragraphIndex } = sentence;
    groups[paragraphIndex] = groups[paragraphIndex] ?? [];
    groups[paragraphIndex].push(sentence);
    return groups;
  }, {});
  return Object.keys(groupedSentences).map((index) => {
    const sortedSentences = groupedSentences[index].sort(
      (a: Sentence, b: Sentence) => a.startIndex - b.startIndex
    );
    return sortedSentences.reduce((paragraph: Paragraph, sentence: Sentence) => {
      if (!paragraph.startIndex || paragraph.startIndex > sentence.startIndex) {
        paragraph.startElement = sentence.startElement;
        paragraph.startOffset = sentence.startOffset;
        paragraph.startIndex = sentence.startIndex;
      }
      if (!paragraph.endIndex || paragraph.endIndex < sentence.endIndex) {
        paragraph.endElement = sentence.endElement;
        paragraph.endOffset = sentence.endOffset;
        paragraph.endIndex = sentence.endIndex;
      }
      if (paragraph.text) {
        paragraph.text += ` ${sentence.text}`;
      } else {
        paragraph.text = sentence.text;
        paragraph.paragraphIndex = sentence.paragraphIndex;
        paragraph.paragraphType = sentence.paragraphType;
      }
      return paragraph;
    }, {});
  });
};

export default paragraphLookup;
